import Phaser from 'phaser';
import gameData from '../gameData';
import ABCyaPhaser from '@abcya/abcya_phaser';
import SoundAssetKeys from '../SoundAssetKeys';
import FontKeys from '../FontKeys';
import Keyboard from './Keyboard';

export default class Intro extends Phaser.Scene {
  static get KEY() { return 'Intro'; }

  create() {
    console.log('starting Intro');
    gameData.currentScene = 'Intro';
    gameData.gameOver = false;
    gameData.gamePaused = false;
    gameData.level = 1;
    gameData.gameMode = 'all';
    gameData.placementCounter = 0;
    gameData.tries = 0;

    this.mid = ABCyaPhaser.Scene.getScreenMidPoint(this);

    this.bg = ABCyaPhaser.Images.addImage(this.mid.x, 30, 'welcomeKeys', this);
    this.bg.setDepth(1);

    this.cameras.main.backgroundColor.setTo(183, 183, 183);

    this.jingle = ABCyaPhaser.Audio.createSound(this);
    ABCyaPhaser.Audio.playSound(SoundAssetKeys._jingle, this.jingle, .3, true);

    this.createTile();
    this.createCursor();
    this.createStyles();
  }

  createCursor() {
    this.cursor = ABCyaPhaser.Images.addImage(this.mid.x, -150, 'Cursor', this);

    this.cursor.setDepth(1);

    ABCyaPhaser.Tweens.addTween(this.cursor,1500,{ x: 355, y: 85, yoyo: true, hold: 500 },Phaser.Math.Easing.Quadratic.Out,() => {
      ABCyaPhaser.Tweens.addTween(this.cursor, 1500, { x: 935, y: 195, yoyo: true, hold: 500 }, Phaser.Math.Easing.Quadratic.Out);
    });
  }

  createTile() {
    this.tile1 = ABCyaPhaser.Images.addImage(this.mid.x, -150, 'Key_Y', this);
    this.tile2 = ABCyaPhaser.Images.addImage(this.mid.x, -150, 'Key_E', this);

    this.tile1.setScale(1.25, 1.25);
    this.tile2.setScale(1.25, 1.25);

    this.tile1.setDepth(1);
    this.tile2.setDepth(1);

    ABCyaPhaser.Tweens.addTween(
      this.tile1,
      1500,
      { x: 360, y: 81 },
      Phaser.Math.Easing.Quadratic.Out,
      () => {
        ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._click, this);
        ABCyaPhaser.Tweens.addTween(this.tile1, 750, { scaleX: 1, scaleY: 1 }, Phaser.Math.Easing.Bounce.Out);
      }
    );
    ABCyaPhaser.Tweens.addTween(
      this.tile2,
      1500,
      { x: 937, y: 194, delay: 3500 },
      Phaser.Math.Easing.Quadratic.Out,
      () => {
        ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._click, this);
        ABCyaPhaser.Tweens.addTween(this.tile2, 750, { scaleX: 1, scaleY: 1 }, Phaser.Math.Easing.Bounce.Out);
      }
    );
  }

  createStyles() {
    this.styles = ['Btn_Classic', 'Btn_Wood', 'Btn_Rnbw', 'Btn_Lava', 'Btn_SciFi', 'Btn_Slime'];
    this.btns = [];

    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._tween, this);

    this.title = ABCyaPhaser.Text.addText(this.mid.x, this.mid.y - 85, 34, '0x000000', FontKeys._bpreplayregular, 'SELECT A STYLE', this, true);

    for (let i = 0; i < this.styles.length; i++) {
      const style = ABCyaPhaser.Buttons.addSimpleButton(0, 0, this.styles[i], null, () => {
        this.goToSelect(style);
      }, this, { disabledTint: '0xFFFFFF' });
      style.setEnabled(false);
      this.btns.push(style);

      if (i === 0 || i === 2 || i === 4) {
        style.setPosition(-500, 350 + (70 * i));

        ABCyaPhaser.Tweens.addTween(
          style,
          2000,
          { x: 80, delay: 500 + (200 * i) },
          Phaser.Math.Easing.Quadratic.Out,
          () => {style.setEnabled(true);}
        );
      }
      else if (i === 1 || i === 3 || i === 5) {
        style.setPosition(1400, 280 + (70 * i));

        ABCyaPhaser.Tweens.addTween(
          style,
          2000,
          { x: 944, delay: 500 + (200 * i) },
          Phaser.Math.Easing.Quadratic.Out,
          () => {style.setEnabled(true);}
        );
      }
    }
  }

  goToSelect(btn) {
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._click, this);
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._tween, this);

    let mode;
    if (btn.frame.name === 'Btn_Classic') mode = 'Classic';
    else if (btn.frame.name === 'Btn_Wood') mode = 'Wood';
    else if (btn.frame.name === 'Btn_Rnbw') mode = 'Rnbow';
    else if (btn.frame.name === 'Btn_Lava') mode = 'Lava';
    else if (btn.frame.name === 'Btn_SciFi') mode = 'SciFi';
    else if (btn.frame.name === 'Btn_Slime') mode = 'Slime';
    gameData.gameStyle = mode;

    ABCyaPhaser.Tweens.addTween(
      this.title,
      1000,
      { alpha: 0 },
      Phaser.Math.Easing.Linear,
      () => {this.createSelect();}
    );

    for (let i = 0; i < this.btns.length; i++) {
      this.btns[i].setEnabled(false);

      this.tweens.killTweensOf(this.btns[i]);

      if (i === 0 || i === 2 || i === 4) {
        ABCyaPhaser.Tweens.addTween(this.btns[i], 1000, { x: -500 }, Phaser.Math.Easing.Quadratic.In);
      }
      else if (i === 1 || i === 3 || i === 5) {
        ABCyaPhaser.Tweens.addTween(this.btns[i], 1000, { x: 1400 }, Phaser.Math.Easing.Quadratic.In);
      }
    }
  }

  createSelect() {
    this.styles = ['Btn_Classic', 'Btn_Wood', 'Btn_Rnbw', 'Btn_Lava', 'Btn_SciFi', 'Btn_Slime'];

    const bg = ABCyaPhaser.Images.addImage(this.mid.x, this.mid.y, `${gameData.gameStyle}_BG`, this);
    bg.setDepth(0);
    bg.setAlpha(0);

    let tint;
    if (gameData.gameStyle === 'Wood' || gameData.gameStyle === 'Classic' || gameData.gameStyle === 'SciFi') {
      tint = 0xFFFFFF;
    }
    else {
      tint = 0x000000;
    }

    this.title.destroy();
    this.title = ABCyaPhaser.Text.addText(this.mid.x, this.mid.y - 85, 34, tint, FontKeys._bpreplayregular, 'SELECT A CHALLENGE', this, true);
    this.title.setAlpha(0);

    this.all = ABCyaPhaser.Buttons.addSimpleButton(-100, 370, 'AllKeys_Btn', null, () => {
      this.enableBtns(this.all);
    }, this, { disabledTint: '0xFFFFFF' });
    this.all.setEnabled(false);
    this.letters = ABCyaPhaser.Buttons.addSimpleButton(1250, 370, 'LtrsNmbrs_Btn', null, () => {
      this.enableBtns(this.letters);
    }, this, { disabledTint: '0xFFFFFF' });
    this.letters.setEnabled(false);
    this.allO = ABCyaPhaser.Images.addImage(this.mid.x / 2 + 45, this.all.y - 2, 'AllKeys_Outline', this);
    this.allO.setAlpha(0);
    this.lettersO = ABCyaPhaser.Images.addImage(this.mid.x + 110, this.letters.y - 2, 'LtrsNmbrs_Outline', this);
    this.lettersO.setAlpha(0);

    this.keyboard = new Keyboard(this);
    this.keyboard.setPosition(this.mid.x, 1000);
    this.keyboard.hideAllKeys();

    this.select1 = ABCyaPhaser.Images.addImage(this.mid.x, 574, 'AllKeys', this);
    this.select1.setAlpha(0);
    this.select2 = ABCyaPhaser.Images.addImage(this.mid.x, 546, 'LtrsNmbrs', this);
    this.select2.setAlpha(0);

    this.play = ABCyaPhaser.Buttons.addSimpleButton(908, 370, 'Popup_Play', null, () => {
      this.cleanUp();
    }, this, { disabledTint: '0xFFFFFF' });
    this.play.setEnabled(false);
    this.play.setAlpha(0);

    for (let i = 0; i < this.btns.length; i++) {
      this.btns[i].destroy();
    }
    this.btns = [];

    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._tween, this);
    ABCyaPhaser.Tweens.addTween(bg, 1000, { alpha: 1 }, Phaser.Math.Easing.Linear);
    ABCyaPhaser.Tweens.addTween(this.title, 1000, { alpha: 1 }, Phaser.Math.Easing.Linear);
    ABCyaPhaser.Tweens.addTween(this.keyboard, 1000, { y: 585 }, Phaser.Math.Easing.Quadratic.Out);
    ABCyaPhaser.Tweens.addTween(this.all, 1000, { x: this.mid.x / 2 + 45 }, Phaser.Math.Easing.Quadratic.Out);
    ABCyaPhaser.Tweens.addTween(
      this.letters,
      1000,
      { x: this.mid.x + 110 },
      Phaser.Math.Easing.Quadratic.Out,
      () => {
        this.all.setEnabled(true);
        this.letters.setEnabled(true);
      }
    );
  }

  enableBtns(btn) {
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._click, this);
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._tween, this);

    let mode;
    if (btn.frame.name === 'AllKeys_Btn') {
      mode = 'all';

      this.keyboard.unhideAllKeys(true);
    }
    else if (btn.frame.name === 'LtrsNmbrs_Btn') {
      mode = 'letters';

      this.keyboard.hideSymbols(true);
      this.keyboard.unhideLetters(true);
    }
    gameData.gameMode = mode;

    ABCyaPhaser.Tweens.addTween(
      this.play,
      250,
      { alpha: 1 },
      Phaser.Math.Easing.Linear,
      () => {this.play.setEnabled(true);}
    );
  }

  cleanUp() {
    console.log('going to level 1');
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._click, this);
    this.jingle.destroy();

    this.play.setEnabled(false);
    this.play.destroy();
    this.all.setEnabled(false);
    this.all.destroy();
    this.letters.setEnabled(false);
    this.letters.destroy();

    this.keyboard.destroy();
    this.allO.destroy();
    this.lettersO.destroy();
    this.cursor.destroy();
    this.tile1.destroy();
    this.tile2.destroy();

    this.bg.destroy();

    this.scene.start('Game');
  }
}